import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authErrors, resetAuthErrors } from '../api';
import { Alert, Button, Paper, Typography, Box, Divider } from '@mui/material';
import EmptyState from './common/EmptyState';

export default function AuthError() {
  const { user, logout } = useAuth();
  
  // Handle manual logout 
  const handleLogout = () => {
    resetAuthErrors();
    logout();
  };
  
  if (!authErrors.whitelistError) return null;
  
  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 8 }}>
      <Alert severity="error" sx={{ mb: 3 }}>Access Denied</Alert>
      <EmptyState
        title="Not Authorized"
        message={(authErrors.message || 'You are not authorized to access this application.') + (user?.email ? ` Signed in as ${user.email}.` : '')}
        action={(
          <Button variant="contained" color="primary" onClick={handleLogout} size="large">
            Sign Out and Try Another Account
          </Button>
        )}
      />
    </Paper>
  );
} 